import { UserTagBadge } from '@/components/user/UserTagBadge';

type PlanTag = {
    tag_id: number;
    tag_nome: string;
    tag_cor_texto: string;
    tag_cor_fundo: string;
    tag_imagem?: string | null;
    tag_descricao?: string | null;
};

/** Plano de `GET /planos`: pode trazer `tag` completo ou só `tag_id` + `tag_imagem`. */
/** `tag_id` pode vir como número ou string (JSON / formulários). */
export type PlanWithOptionalTag = {
    tag?: PlanTag | null;
    tag_id?: number | string | null;
    tag_imagem?: string | null;
    name?: string;
    description?: string | null;
};

function resolveTagForBadge(plan: PlanWithOptionalTag): PlanTag | null {
    const embedded = plan.tag;
    if (embedded?.tag_id != null) {
        return {
            ...embedded,
            tag_imagem: embedded.tag_imagem ?? undefined,
        };
    }

    const rawId = plan.tag_id;
    if (rawId == null || rawId === '') return null;
    const tag_id = typeof rawId === 'number' ? rawId : Number(rawId);
    if (!Number.isFinite(tag_id) || tag_id < 1) return null;

    const img = typeof plan.tag_imagem === 'string' ? plan.tag_imagem.trim() : '';
    const label = (plan.name && String(plan.name).trim()) || 'VIP';

    if (img) {
        return {
            tag_id,
            tag_nome: label,
            tag_cor_texto: '#ffffff',
            tag_cor_fundo: '#c2410c',
            tag_imagem: img,
            tag_descricao: plan.description ?? null,
        };
    }

    return {
        tag_id,
        tag_nome: label,
        tag_cor_texto: '#ffffff',
        tag_cor_fundo: '#c2410c',
        tag_descricao: plan.description ?? null,
    };
}

/** Tag VIP incluída em `GET /planos` (`tag` ou `tag_id` + `tag_imagem`). */
export function PlanVipTagBadge({
    plan,
    size = 'sm',
    className = '',
}: {
    plan: PlanWithOptionalTag;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}) {
    const t = resolveTagForBadge(plan);
    if (!t?.tag_id) return null;

    const tagForBadge = {
        ...t,
        tag_imagem: t.tag_imagem ?? undefined,
    };

    return (
        <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
            <UserTagBadge tag={tagForBadge} size={size} showPopover />
        </div>
    );
}
